import { View } from 'react-native'
import { styled } from '~/utils'

export const Header = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacingInlineTwopulse,
      padding: theme.spacingInlineNone,
      backgroundColor: 'transparent',
      borderColor: theme.colorNone,
      borderWidth: theme.borderWidthNone,
      borderRadius: theme.borderRadiusNone,
    },
    variants: {},
  }
})
